import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { SIMPLMenuHeader } from '../../components/commons/header/SIMPLMenuHeader';
import { Layout } from '../../components/commons/layout/Layout';
import { OutputTemplateEditor } from '../../components/commons/outputtemplate/OutputTemplateEditor';
import DecommissionStatus from '~/models/enums/DecommissionStatus.enum';
import { RequesterInfo } from '~/models/types/ContractsTypes';

// Mock OT body, same example as the design. UI only until the BE exposes the OT body for a requester.
const MOCK_OT_BODY = `<!-- src/main/resources/templates/provisioned-resource-vm-email-template.html -->

<html xmlns:th="http://www.w3.org/1999/xhtml">
<body>
<p>Dear User,</p>
<p>Please find below the access details for the requested resource (Virtual Machine - VM):</p>
<p>
  <strong>VM IP Address:</strong><br>
  <span th:if="\${#lists.isEmpty(address)}">No IPs available</span>
  <span th:each="ip : \${address}">
    <span th:text="\${ip}"></span><br>
  </span>
</p>
<strong>Account:</strong><br>
<p>
  <strong>Username:</strong> <span th:text="\${username}"></span><br>
  <strong>Password:</strong> <span th:text="\${password}"></span><br>
</p>

<p>...</p>
</body>
</html>`;

interface LocationState {
  contractItem?: RequesterInfo;
}

export const OutputTemplateWorkspace = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id: paramId } = useParams<{ id: string }>();
  const { contractItem } = (location.state || {}) as LocationState;

  // Prefer state (from row action), fall back to URL param (direct navigation)
  const id = contractItem?.requesterUniqueId ?? paramId ?? '—';

  const handleSave = () => {
    // Pass saved ID back via navigation state so SIMPLContracts can update savedDraftIds
    navigate('/contracts', { state: { savedId: id } });
  };

  return (
    <SIMPLMenuHeader>
      <Layout>
        <OutputTemplateEditor
          resourceId={id}
          initialBody={MOCK_OT_BODY}
          showGenerateLink={
            contractItem?.resourceStatus ===
            DecommissionStatus.AWAITING_PROVISIONING_INPUT
          }
          onBack={() => navigate('/contracts')}
          onCancel={() => navigate('/contracts')}
          onSave={handleSave}
        />
      </Layout>
    </SIMPLMenuHeader>
  );
};
